/*
 * Public API Surface of dynamic-template
 */

export * from './lib/dynamic-template.service';
export * from './lib/dynamic-template.component';
export * from './lib/dynamic-template.module';
